import AppealsSection from '../../../sections/AdminDashboard/Configuration/Appeals';

const Appeals = () => <AppealsSection />;

export default Appeals;
